import React, { ReactElement } from "react";
import { GQLUrls } from "@gql/types/gql";
import { useQuery } from "@tanstack/react-query";
import styles from "./style.module.scss";
import { translate } from "@helpers/translationObjectFormatter";
import {
    ISitemapPageProps,
    TranslationsObject,
} from "@genericTypes/sharedTypes";
import { resolveURL, titleDecoder } from "@lib/sharedUtils";
export default function SiteMap({
    onSetLoading,
}: {
    onSetLoading: CallableFunction;
}): ReactElement {
    const { data: pageProps } = useQuery<ISitemapPageProps, Error>({
        queryKey: ["sitemapPageProps"],
    });
    const { posts, categories, offers } = pageProps ?? {};
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    const staticPages = [
        {
            title: translate(translations, "several_siteMapPage_PartnerWithUs"),
            link: "/partner-with-us",
        },
        {
            title: translate(
                translations,
                "several_privacyPolicyPage_PrivacyPolicy",
            ),
            link: "/privacy-policy",
        },
        {
            title: translate(translations, "several_aboutUsPage_AboutUsTitle"),
            link: "/about-us",
        },
        {
            title: translate(translations, "several_contactUS_mainTitle"),
            link: "/contact-us",
        },
        {
            title: translate(translations, "several_siteMapPage_HomePage"),
            link: "/",
        },
    ];
    const startLoadingHandler = () => {
        onSetLoading(true);
    };
    return (
        <section
            className={`flex lg:flex-row flex-col gap-10 my-10  ${styles["mainContainer"]}`}
        >
            <div>
                <h2>
                    {translate(translations, "several_siteMapPage_Vendors")}
                </h2>
                {categories?.map((category) => (
                    <section key={category.label}>
                        <a
                            href={`${resolveURL(category.url as GQLUrls)}`}
                            className={`${styles["categoryName"]} font-semibold mt-4 mb-4 text-lg leading-6 block`}
                            onClick={startLoadingHandler}
                        >
                            {titleDecoder(
                                (category.label ??
                                    category.name ??
                                    category.title) as string,
                            )}
                        </a>

                        <ul className={`${styles["offerList"]} `}>
                            {offers
                                ?.filter(
                                    (offer) =>
                                        offer?.categories?.[0]?.id ===
                                        category.id,
                                )
                                .map((offer, idx) => (
                                    <li
                                        key={`${offer?.title as string}-${idx}`}
                                        itemScope
                                        itemType="https://schema.org/Offer"
                                    >
                                        <a
                                            itemProp="name"
                                            href={`${resolveURL(
                                                offer.url as GQLUrls,
                                            )}`}
                                            onClick={startLoadingHandler}
                                        >
                                            {titleDecoder(
                                                (offer?.title
                                                    ? offer?.title
                                                    : offer?.name) as string,
                                            )}
                                        </a>
                                    </li>
                                ))}
                        </ul>
                    </section>
                ))}
            </div>
            <div>
                <h2>{translate(translations, "several_siteMapPage_Blogs")}</h2>
                <ul className={`${styles["offerList"]} mt-4`}>
                    {posts?.map((el) => (
                        <li
                            key={el?.id}
                            itemScope
                            itemType="https://schema.org/Blog"
                        >
                            <a
                                href={`${el.url?.url as string}`}
                                itemProp="name"
                                onClick={startLoadingHandler}
                            >
                                {titleDecoder(el.title as string)}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <div>
                <h2>{translate(translations, "several_siteMapPage_Pages")}</h2>
                <ul className={`${styles["offerList"]} mt-4`}>
                    {staticPages.map((page, index) => (
                        <li key={index}>
                            <a onClick={startLoadingHandler} href={page.link}>
                                {titleDecoder(page.title)}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
